import * as types from './mutation-types'

const setTitle = ({commit}, title) => {
  commit(types.SET_NAVIGATOR_TITLE, title)
}

const setLinks = ({commit}, links) => {
  commit(types.SET_NAVIGATOR_LINKS, links)
}

const setFineplay = ({commit}, fineplay) => {
  commit(types.SET_STATUS_FINEPLAY, fineplay)
}

const toogleFineplayScreenChat = ({commit}, enableFineplay) => {
  commit(types.TOOGLE_FINEPLAY_SCREEN_CHAT, enableFineplay)
}

export default {
  setTitle,
  setLinks,
  setFineplay,
  toogleFineplayScreenChat
}



// WEBPACK FOOTER //
// ./src/store/modules/navigator/actions.js